import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { taxId, conpanyName, releaseDate, director, creator, method, date, sendTo, chiefAccountant, address, unit },
} = checkout;

const validation = Yup.object().shape({
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [creator.name]: Yup.string().required(creator.errorMsg),
  [address.name]: Yup.string().required(address.errorMsg),
  // [sendTo.name]: Yup.string().required(sendTo.errorMsg),
  [director.name]: Yup.string().required(director.errorMsg),
  [chiefAccountant.name]: Yup.string().required(chiefAccountant.errorMsg),
  [unit.name]: Yup.string().required(unit.errorMsg),
  // [taxId.name]: Yup.string()
  //   .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
  //   .required(taxId.errorMsg),
});

export default validation;
